import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, intlShape } from 'react-intl';

import useProductSchema from '../../../../hooks/schema/useProductSchema';
import FullProduct from '../../../../models/product/FullProduct';
import { modelOf } from '../../../../prop-types';
import { LocationContextPropType } from '../../../../services/LocationContext';
import RouteService from '../../../../services/RouteService';
import AccountStore from '../../../../store/AccountStore';
import ConfigStore from '../../../../store/ConfigStore';
import CountryStore from '../../../../store/CountryStore';
import CurrencyStore from '../../../../store/CurrencyStore';
import SEOSchema from '../../../head/SEOSchema';

const ProductSchema = ({
  accountStore,
  configStore,
  countryStore,
  currencyStore,
  routeService,
  locationContext,
  intl,
  product,
  activeProductId,
}) => {
  const { getProductSchema, getBaseSchema } = useProductSchema({
    accountStore,
    configStore,
    countryStore,
    currencyStore,
    routeService,
    locationContext,
    intl,
  });

  const productSchema = getProductSchema(product, activeProductId);
  const baseSchema = getBaseSchema(product);

  return (
    <SEOSchema
      data={{
        ...baseSchema,
        ...productSchema,
      }}
    />
  );
};

ProductSchema.propTypes = {
  accountStore: modelOf(AccountStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  countryStore: modelOf(CountryStore).isRequired,
  currencyStore: modelOf(CurrencyStore).isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired,
  locationContext: LocationContextPropType.isRequired,
  intl: intlShape.isRequired,
  product: modelOf(FullProduct).isRequired,
  activeProductId: PropTypes.string,
};

export default injectIntl(
  inject(
    'accountStore',
    'configStore',
    'countryStore',
    'currencyStore',
    'routeService',
    'locationContext'
  )(observer(ProductSchema))
);
